var isPage = "";
var Animate = {
	top: 0,
	show: 0
}
var animations = [];
var common = {
	init: ()=>{
		var resizeFlag;
		var resizeTimer = null;
		var $body = $("body");
		common.resize();
		common.nav();
		setTimeout(function(){
			common.checkParam();
			common.resize();
			common.nav();
			common.scrl();
			if(isPage === "subscription"){
				subscription.init();
			}
			$("body").removeClass("disable");
		}, 600);
		$("a.scroll").off().on("click", function(){
			let posY = $("#link_lp").offset().top - $("header").height();
			common.scrollToPosition(posY, 1000);
		});
		$(document).off("scroll touchmove").on("scroll touchmove", function(){
			common.scrl();
		});
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			console.log("resize callback")
			resizeTimer = null;
		};

		$(window).off("resize").on("resize", function(){
			if(!$body.hasClass("resize")){
				$body.addClass("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
	},
	nav: ()=>{
		$("a#btn_menu").off().on("click", function(){
			if( !$html.classList.contains("menu") ){
				$html.classList.add("menu");
			}else{
				$html.classList.remove("menu");
			}
		});
		$("#bg_drawer").off().on("click", function(){
			$html.classList.remove("menu");
		});
	},
	resize: ()=>{
		var winW = window.innerWidth;
		var winH = window.innerHeight;
		var $body = $("body");
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if(isPage === "top"){
			home.resize();
		}else if(isPage === "subscription"){
			subscription.resize();
		}
		animations = [];
		$(".a").each(function(i){
			let _a = object(Animate);
			_a.top 	= $(this).offset().top;
			if(isSmallScreen){
				_a.show = Math.floor(_a.top + window.innerHeight/2);
			}else{
				_a.show = Math.floor(_a.top + window.innerHeight/3);
			}
			animations.push(_a);
		});
		//console.log(animations);
		
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
	},
	scrollToPosition: (posY, duration) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic",
			flag 	= true;
		$page.animate({
			scrollTop : posY + "px"
		},{
			"duration" 	: duration,
			"easing" 	: ease,
			"complete"	: function(){
				if(flag){
					flag = false;
				}
			}
		});
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height(),
			showPoint = window.innerHeight;
		if(!isSmallScreen){
			showPoint = window.innerHeight/2;
		}
		if(topD >= showPoint){
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled")
			}
		}else{
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled");
			}
		}
		let alen = animations.length;
		
		for(var a = 0; a < alen; a++){
			if(a === alen - 1){
				if(btmD >= animations[a].show){
					activeAnimate(a);
				}
			}else{
				if(btmD >= animations[a].show){
					activeAnimate(a);
				}
			}
		}
		function activeAnimate(a){
			let $blk = $(".a").eq(a);
			if(!$blk.hasClass("animate")){
				$blk.addClass("animate");
				setTimeout(function(){
					$blk.addClass("animated");
				}, 1000);
			}
		}
	},
	checkParam: function(){
		if(isPage === "service"){
			let param 	= location.search.substring(1),
				pair 	= param.split('&'),
				hasParam = false;
			if(param === ""){
				//パラメータがない場合
				$("#btn_floating").addClass("pc");
			}else{
				//パラメータアリ
				$(".set .link_arrow").remove();
				$("#glbnav").remove();
				$("header .nav_list_flex").remove();
				$("a#btn_menu").remove();
			}
		}else{
			//common.checkParamOther();
		}
	},
	checkParamOther: function(){
		let param 	= location.search.substring(1),
			pair 	= param.split('&'),
			hasParam = false;
		$("#btn_floating").addClass("pc");
	}
}

document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	common.init();
});